import {
  HIGHLY_SENSITIVE,
  SENSITIVE,
  V2_SENSITIVE,
} from '../constants/SensitiveScopes';

const TEMP_CONSIDER_AS_V2_PERMISSIONS = ['files.sensitive.read'];

export const isSensitiveScope = (scopeName: string) =>
  scopeName.includes(SENSITIVE);

export const isHighlySensitiveScope = (scopeName: string) =>
  scopeName.includes(HIGHLY_SENSITIVE);

export const isV2SensitiveScope = (scopeName: string) =>
  isSensitiveScope(scopeName) &&
  (scopeName.endsWith(`.${V2_SENSITIVE}`) ||
    TEMP_CONSIDER_AS_V2_PERMISSIONS.includes(scopeName));

export const removeV2ScopeIndicator = (scopeName: string) =>
  isV2SensitiveScope(scopeName)
    ? scopeName.replace(`.${V2_SENSITIVE}`, '')
    : scopeName;
